export const COORD_PROVIDER_GPS = 0;
export const COORD_PROVIDER_NETWORK = 1;
